var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRedDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48796 6.38281C9.3383 6.02216 8.94998 5.76483 8.55155 5.7698C8.28559 5.7698 8.0166 5.88306 7.82851 6.07283L6.25086 7.63252L6.25086 1.54969C6.25086 1.28839 6.14771 1.02809 5.96366 0.843293C5.77962 0.657504 5.51872 0.544242 5.25377 0.540268C4.98883 0.536294 4.71883 0.641607 4.53073 0.834352C4.3386 1.01915 4.23141 1.28442 4.23545 1.54969L4.23545 7.64689L2.64388 6.07283C2.46388 5.88306 2.19893 5.7698 1.92893 5.76483C1.66398 5.76483 1.39398 5.87114 1.20589 6.05494C1.01376 6.23676 0.902519 6.50004 0.906564 6.76134C0.910609 7.02661 1.0269 7.28692 1.21499 7.46774L4.35085 10.5695C4.82917 11.0405 5.65131 11.0405 6.12558 10.5695L9.26144 7.46774C9.54358 7.19452 9.63762 6.74843 9.48796 6.38281Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.1302,
    y1: 12.3731,
    x2: 10.1302,
    y2: 0.618555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedDown);
export default __webpack_public_path__ + "static/media/arrowRedDown.fac68821d1c09140854dfc5043cb9ae9.svg";
export { ForwardRef as ReactComponent };